import styled from '@emotion/styled';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import React, { useState } from 'react';
import Sidemenu from './Sidemenu';
import Submenu from './Submenu';

export interface SubNavItemProps {
  navItem: NavItem;
  state: SubNavItemState;
}

export enum SubNavItemState {
  previous,
  current,
  next,
}

interface WrapperProps {
  state: SubNavItemState;
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: ${theme.transitions.create(['transform', 'opacity'], {
    delay: 50,
  })};

  ${({ state }) => {
    if (state !== SubNavItemState.current) {
      return `
        transition: ${theme.transitions.create(['transform', 'opacity'], {
          duration: theme.transitions.duration.complex,
        })};
        transform: translateX(${state === SubNavItemState.next ? '' : '-'}1rem);
        opacity: 0;
        pointer-events: none;
      `;
    }

    return '';
  }}
`;

function SubNavItem({ navItem, state }: SubNavItemProps) {
  const [subMenuState, setSubMenuState] = useState();

  return (
    <Wrapper state={state}>
      <Submenu navItem={navItem} subMenuState={subMenuState} />
      {navItem.sidemenu && (
        <Sidemenu navItem={navItem} handleSubMenu={setSubMenuState} />
      )}
    </Wrapper>
  );
}

export default React.memo(SubNavItem);
